"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkSetQuality = exports.intersectSets = exports.unionSets = exports.subtractSets = void 0;
const subtractSets = (a, b) => {
    if (a.size === 0)
        return new Set();
    const out = new Set();
    for (const v of a)
        if (!b.has(v))
            out.add(v);
    return out;
};
exports.subtractSets = subtractSets;
const unionSets = (a, b) => {
    if (a.size === 0)
        return new Set(b);
    if (b.size === 0)
        return new Set(a);
    const out = new Set(a);
    for (const v of b)
        out.add(v);
    return out;
};
exports.unionSets = unionSets;
const intersectSets = (a, b) => {
    if (a.size === 0 || b.size === 0)
        return new Set();
    const [small, large] = a.size <= b.size ? [a, b] : [b, a];
    const out = new Set();
    for (const v of small)
        if (large.has(v))
            out.add(v);
    return out;
};
exports.intersectSets = intersectSets;
const checkSetQuality = (a, b) => {
    if (a === b)
        return true;
    if (a.size !== b.size)
        return false;
    if (a.size === 0)
        return true;
    for (const v of a)
        if (!b.has(v))
            return false;
    return true;
};
exports.checkSetQuality = checkSetQuality;
//# sourceMappingURL=set.js.map